// Loop through all elements with data-track attribute
document.querySelectorAll( '[data-track]' ).forEach( function( ofhNodeToTrack ) {

  // Add a click event listener
  ofhNodeToTrack.addEventListener( 'click', function( event ) {

    // Stop the link being followed
    event.preventDefault();

    // Stop the event bubbling
    event.stopPropagation();

    // Get the clicked link element
    let clickedLinkElement = event.currentTarget;

    // Get the url of the clicked link
    let url = clickedLinkElement.getAttribute( 'href' );

    // Get the values from the data-track attribute
    let dataTrackArray = clickedLinkElement.getAttribute( 'data-track' ).split( '|' );

    // Get the category
    let category = dataTrackArray[ 0 ].toLowerCase();

    // Get the action
    let action = dataTrackArray[ 1 ].toLowerCase();

    // Get the link text
    let text = clickedLinkElement.innerText.toLowerCase();

    // Get the label
    let label = ( 2 in dataTrackArray ? dataTrackArray[ 2 ].toLowerCase() : text + ' - ' + window.location.pathname );

    // If Matomo is loaded (not always the case due to privacy extensions and local testing)
    if ( typeof window._paq !== 'undefined' ) {

      // Track the click
      window._paq.push(
        [
          'trackEvent',
          category,
          action,
          label
        ]
      );
    }

    // If Mixpanel is loaded (not always the case due to privacy extensions and local testing) and it's a CTA
    if ( typeof mixpanel !== 'undefined' && typeof mixpanel.track !== 'undefined' && category === 'call to action' ) {

      // Track the click
      mixpanel.track( 'Call to Action', {
        'cta text': text,
        'cta url': url,
        'cta location': window.location.pathname,
      } )
    }

    // Wait for 100ms before following the link so the tracking has time to take effect
    setTimeout(
      function() {
        window.location.href = url;
      },
      100
    );

  } );

} );
